import React from 'react';
import { Button } from 'antd';

import { HiOutlineSun, HiOutlineMoon } from 'react-icons/hi';

export const ToggleThemeButton = ({darkTheme, toggleTheme}) => {
    return (
        <div className='absolute bottom-[30px] left-[15px] flex items-center justify-center'>
            <Button onClick={toggleTheme}>
                {darkTheme ? <HiOutlineSun /> : <HiOutlineMoon />}
            </Button>
        </div>
  )
}
